import { render, staticRenderFns } from "./ProFormaInvoicesTable.vue?vue&type=template&id=3cf70b89"
import script from "./ProFormaInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ProFormaInvoicesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports